import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';


export const SearchBtnWrap = styled.button<{ isInactive: boolean }>`
    width: 22px;
    height: 22px;
    padding: 0;
    background-color: transparent;
    border: none;
    cursor: ${p => p.isInactive ? 'auto' : 'pointer'};

    &:focus {
        outline: none;
    }
`;

export const SearchIcon = styled.svg<{ isInactive: boolean }>`
    & > path {
        stroke: ${COLORS.GRAY_DARK};
    }
`;
